import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';

const OldThemedButton = styled(Button)(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  height: 36,
  color: theme.palette.common.white,
  textTransform: 'none',
  backgroundColor: '#0F7B85',
  border: 0,
  borderRadius: 4,
  '&:disabled': {
    color: 'white',
    backgroundColor: '#BDBDBD',
  },
}));

export default OldThemedButton;
